enum Whitelabel {
    OCVIBE = "ocvibe",
}

export default Whitelabel;
